import { render } from "./FIT.vue?vue&type=template&id=24f30f99&scoped=true"
import script from "./FIT.vue?vue&type=script&lang=js"
export * from "./FIT.vue?vue&type=script&lang=js"

import "./FIT.vue?vue&type=style&index=0&id=24f30f99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f30f99"]])

export default __exports__